import React from 'react';
import { PaginationDropdown } from '@amzn/storm-ui';
import { PAGE_SIZES } from './constants/PageSizes';
import { useTranslation } from 'react-i18next';

export interface ResultsPerPageProps {
  id: string;
  currentSize: number;
  pageSizes?: number[];
  onPageChangeCb: (page: number) => void;
  onPageSizeChangeCb: (size: number) => void;
}

export const CustomResultsPerPage: React.FC<ResultsPerPageProps> = ({
  id,
  currentSize,
  pageSizes = PAGE_SIZES,
  onPageChangeCb,
  onPageSizeChangeCb,
}) => {
  const { t } = useTranslation();
  return (
    <PaginationDropdown
      id={id}
      currentSize={currentSize}
      pageSizes={pageSizes}
      onSetPageSize={(newSize) => {
        onPageChangeCb(0);
        onPageSizeChangeCb(newSize);
      }}
      renderPaginationDropdownLabel={(pageSize) =>
        `${t('pagination-results-per-page-label')} ${pageSize}`
      }
    />
  );
};
